import React, { Component } from 'react'
import './index.less'

export default class extends Component {
  render() {
    const { img, name } = this.props
    return (
      <div className="nt-reward-item">
        <img src={img} alt="" />
        <div className="name">{name}</div>
        {/* <div className="date">7D</div> */}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/nationalTemplate/RewardItem/index.js